var _path, _rect, _polygon, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoomBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 298.06 35.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.72,14.15c0-7.8-6.35-14.15-14.15-14.15s-14.15,6.35-14.15,14.15,6.35,14.15,14.15,14.15c3.29,0,6.31-1.14,8.72-3.03l10.58,9.89,4.1-4.38-10.84-10.13c1.01-1.95,1.59-4.15,1.59-6.49"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40.23,
    y: 12.63,
    width: 215.45,
    height: 4
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "298.06 12.63 290.01 12.63 290.01 4.58 286.01 4.58 286.01 12.63 277.96 12.63 277.96 16.63 286.01 16.63 286.01 24.68 290.01 24.68 290.01 16.63 298.06 16.63 298.06 12.63"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 12.63,
    width: 20.1,
    height: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomBar);
export default __webpack_public_path__ + "static/media/zoom-bar.bdfa6b9c.svg";
export { ForwardRef as ReactComponent };